import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { policyEditPanelManagementActions, PolicyEditPanelType } from "../../store/policyEditPanelManagementSlice";

const usePolicyEditPanelManager = () => {
  const dispatch = useDispatch();
  const { openedPanel } = useSelector((state: RootState) => state.policyEditPanelManagement);

  const openPanel = useCallback((panelType: PolicyEditPanelType) => {
    dispatch(policyEditPanelManagementActions.openPanel(panelType));
  }, [dispatch]);

  const closePanel = useCallback(() => {
    dispatch(policyEditPanelManagementActions.closePanel());
  }, [dispatch]);

  return { openedPanel, openPanel, closePanel };
};

export default usePolicyEditPanelManager;